import { URL as NEWURL, } from '../constants';
import { VENDORID as NEWVENDORID } from '../constants';

export default function useFetchDataFromAPI(serviceId) {

    const url = NEWURL;

    const requestOptions = {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: JSON.stringify({
            "serviceId": serviceId,
            "token": sessionStorage.getItem('token'),
            "slipRef": sessionStorage.getItem('slipRef')??0,
            "invoiceStatus": 0, //getAll gerekli mi?
            "slipStatus": 1, //0: Aktif Sepet/Slip; 1: Kayitli Sepet/Slip; 2: Gönderilmis Sepet/Slip; 3: Silinen Sepet/Slip
            "vendorId": NEWVENDORID
        })
    };

    const fetchData = async () => {
        try {
            const response = await fetch(url, requestOptions);
            const json = await response.json();
            if (json.resCode === 200) {
                if (serviceId === 1306) {
                    sessionStorage.setItem('allCategories', JSON.stringify(json.dataSet));
                }
                return json;
            }
            else return;
        } catch (error) {
            console.log("error", error);
        }
    };

    return fetchData();
}
